/**
 * Проверить, что поиск не пуст.
 *
 * @global
 * @function CheckIsSearchNotEmpty
 * @param {object} el jQuery-объект поиска.
 * @param {string} emptyCriteriaWarningMessage Предупреждение, выводимое в случае, когда поиск ничего не вернул.
 * @param {function} callback Callback-функция, вызываемая по окончании поиска.
 * @returns {boolean} True - поиск вернул результаты, иначе False.
 * @constructor
 */
function CheckIsSearchNotEmpty(el, emptyCriteriaWarningMessage, callback) {
  var isAnyCriteriaFilled = false;
  var criteriaContainer = $(el).parents('.Search_Table');
  const criterionInputs = criteriaContainer.find(':text:enabled, input[type=hidden], select');
  $.each(criterionInputs, (i, criterionInput) => {
    // Исключаем критерий архивности
    if (!criterionInput.id.endsWith('ArchiveTaginp') && !criterionInput.id.endsWith('ArchiveTag')) {
      // хак для reference-полей, вызываем событие, чтобы поле корректно заполнилось/очистилось (bug#22966)
      const jCriterionInput = $(criterionInput);
      jCriterionInput.click();
      isAnyCriteriaFilled = !!jCriterionInput.val().trim();
      if (isAnyCriteriaFilled) {
        return false;
      };
    };
  });
  if (!isAnyCriteriaFilled) {
    var dialog = new WA.CMP.dialogs.MessageBox();
    dialog.showWarning(emptyCriteriaWarningMessage, null, null, function () {
      return false;
    });
  } else {
    callback();
    return true;
  }
}

/**
 * Нажатие на кнопку Enter запускает поиск.
 *
 * @global
 * @function BindOnEnterToSearchCrit
 */
function BindOnEnterToSearchCrit() {
  $('div.Search_Table').children().children(':not(.Search_Date_Row)').find('input[type=text]').keyup(function (event) {
    if (event.keyCode == 13 && $('div.rs_container:visible').length == 0) {
      $('input.Search_Btn:visible:first').click();
    }
  });
}

/**
 * Очистить критерии поиска.
 *
 * @global
 * @function ClearSearch
 * @param {string} searchName Имя поиска.
 */
function ClearSearch(searchName) {
  CustomSearch(searchName);
}

/**
 * Восстановить значения поиска по-умолчанию.
 *
 * @function _restoreSearchDefaultValues
 * @param {string} searchName Имя поиска.
 * @private
 */
function _restoreSearchDefaultValues(searchName) {
  let jSearch = $('#Search');
  jSearch.children().remove();
  jSearch.append(window.searches[searchName]);
  ChangePositionSearchButtons(searchName);
  $("#tree_container").redraw();
}

/**
 * Запустить поиск.
 *
 * @global
 * @function CustomSearch
 * @param {string} name Имя поиска
 * @param {object} el jQuery-объект поиска.
 */
function CustomSearch(name, el) {
  $('.explorer-header__logo').hide();
  $('.show-folder-link').show();

  ClearSelectedElements(el);
  SetElementToolBar(el);
  $('#Search').show();
  $('.quick-search').addClass('disabled');
  LoadSearch(name, $('#Search'));
  $('#Tree').hide();
  $("#tree_container").redraw();
}

/**
 * Отобразить поиск заданий.
 *
 * @global
 * @function JobSearch
 * @param {object} el jQuery-объект поиска.
 */
function JobSearch(el) {
  CustomSearch("JOB_SEARCH", el);
  $("#tree_container").redraw();
}

/**
 * Отобразить поиск документов.
 *
 * @global
 * @function SearchEDoc
 * @param {object} el jQuery-объект поиска.
 */
function SearchEDoc(el) {
  CustomSearch("EDOCUMENT_SEARCH", el);
  $("#tree_container").redraw();
}

/**
 * Отобразить поиск задач.
 *
 * @global
 * @function TaskSearch
 * @param {object} el jQuery-объект поиска.
 */
function TaskSearch(el) {
  CustomSearch("TASK_SEARCH", el);
  $("#tree_container").redraw();
}

/**
 * Отобразить общий поиск.
 *
 * @global
 * @function GeneralSearch
 * @param {object} el jQuery-объект поиска.
 */
function GeneralSearch(el) {
  CustomSearch("GENERAL_SEARCH", el);
  $("#tree_container").redraw();
}

/**
 * Загрузить поиск.
 *
 * @global
 * @function LoadSearch
 * @param {string} SearchName Имя поиска
 * @param {object} obj jQuery-объект поиска.
 */
function LoadSearch(SearchName, obj) {
  let jSearch = $(`#${SearchName}`);
  if (window.searches && window.searches[SearchName]) {
    _restoreSearchDefaultValues(SearchName);
  } else {
    window.searches = window.searches || {};

    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: `DynControl.ashx?c=search&name=${SearchName}`,
      cache: false,
      success: (res) => {
        // Сохраним исходное состояние поиска. Применяется ниже при повторном
        // выборе поиска с целью очистки критериев поиска.
        window.searches[SearchName] = res;

        if (!CheckForLoginPage(res)) {
          obj.children().remove();
          obj.append(res);
          $('#spinner').hide().redraw();
          $('#main_container').redraw();
          ChangePositionSearchButtons(SearchName);
        }
        if (SearchName === 'SrchGeneral') {
          DisableIsAllCheckboxNotChecked('', 'input.Search_Btn:first');
        }
        $("#tree_container").redraw();
      }
    });
  }
}

/**
 * Изменяет положение кнопок поиска.
 *
 * @global
 * @function ChangePositionSearchButtons
 * @param {string} SearchName Имя поиска.
 */
function ChangePositionSearchButtons(SearchName) {
  setTimeout(function () {
    if (typeof SearchName === 'string' || SearchName instanceof String) {
      var jSearch = $('#' + SearchName);
      var heightNew = windowHeight() - $('#header').height() - $('#toolbar_container').height() - jSearch.find('.LastSearch').height() * 2 - jSearch.find('.Search_Btn_Td').height() * 2 - 13;
      var jsearchCriterias = jSearch.find('.Search_Criterias');
      var jsearchCriteriasDiv = jSearch.find('.Search_Criterias>div');
      var searchCriteriasDivHeight = jsearchCriteriasDiv.height();
      var searchCriteriasHeight = jsearchCriterias.height();
      if ((searchCriteriasHeight > heightNew) || (jsearchCriteriasDiv.height() > searchCriteriasHeight)) {
        jsearchCriterias.css({
          height: heightNew,
          'margin-right': '-10px',
          'padding-right': '10px',
          overflow: 'scroll',
          '-ms-overflow-style': 'scrollbar',
          'overflow-x': 'hidden',
        });
      }
      if (searchCriteriasDivHeight && searchCriteriasDivHeight < heightNew) {
        jsearchCriterias.css({
          height: jsearchCriteriasDiv.height(),
          overflow: 'hidden',
        });
      }
      if ($.ipad || WA.ENV.isAndroid()) {
        jsearchCriterias.css({
          height: 'inherit',
        });
      }
    }
  }, 10);
}

/**
 * Выполняется после поиска.
 *
 * @global
 * @function AfterSearch
 * @private
 */
function AfterSearch() {
  var searchId = $('.Search_Table:visible').parent().attr('id');
  if (searchId != undefined) {
    ChangePositionSearchButtons(searchId);
    if (searchId === "SrchGeneral") {
      DisableIsAllCheckboxNotChecked("", 'input.Search_Btn:first');
    }
  }
}

/**
 * Запустить поиск.
 *
 * @global
 * @function ExecuteSearch
 * @param {string} name Имя поиска.
 * @param {string} sort Сортировка.
 *
 * @example
 * ExecuteSearch(searchName, '-MODIFIED');
 */
function ExecuteSearch(name, sort) {
  var f = $("form:first");
  var url = f.attr('action');
  ShowTopSpinner(L("SEARCHING"));
  url = ChangeParamInURL(url, 'searchname', name);
  url = ChangeParamInURL(url, 'mode', 'search');
  url = RemoveParamInURL(url, 'show');
  if (name == 'SrchGeneral') {
    url = ChangeParamInURL(url, 'sort', '-RANK');
  } if (sort) {
    url = ChangeParamInURL(url, 'sort', sort);
  } else {
    url = RemoveParamInURL(url, 'sort');
  }
  url = RemoveParamInURL(url, 'uid');
  url = RemoveParamInURL(url, 'refcode');
  url = RemoveParamInURL(url, 'treeitem');
  f.attr('action', url);
  f.submit();
}

/**
 * Запускает поиск последних объектов, с которыми взаимодействовал пользователь.
 * @global
 * @param {String} searchName - имя поиска
 * @param {String} objType - тип искомых объектов
 * @function showLastObjects
 */
function showLastObjects(searchName, objType) {
  switch (objType) {
    case "EDOC":
      executeLastActedObjectsSearch(searchName, 'SrchDocPseudoReader', 'SrchDocPseudoReaded', '-MODIFIED');
      break;
    case "JOB":
      executeLastActedObjectsSearch(searchName, 'SrchJobPseudoModifier', 'SrchJobPseudoModified', '-CREATED');
      break;
    case "TASK":
      executeLastActedObjectsSearch(searchName, 'SrchTaskPseudoModifier', 'SrchTaskPseudoModified', '-MODIFIED');
      break;
    case "FOL":
      executeLastActedObjectsSearch(searchName, 'SrchFolPseudoModifier', 'SrchFolPseudoModified', 'NAME');
      break;
    case "REF":
      DoAction('mode=lastobjects&sort=-MODIFIED&objtype=REF&searchname=' + searchName + '&-uid', false);
      break;
  }
}

/**
 * Заполняет критерии для поиска последних объектов, с которыми взаимодействовал пользователь, и запускает поиск на выполнение.
 * @global
 * @param {String} searchName - имя поиска
 * @param {String} actedByRequisiteId - ИД контрола с реквизитом, определяющим пользователя, для которого выполняется поиск
 * @param {String} actedDateRequisiteId - ИД контрола с реквизитом, определяющим дату, за которую требуется произвести поиск
 * @param {string} sortBy Сортировка.
 * @function executeLastActedObjectsSearch
 */
function executeLastActedObjectsSearch(searchName, actedByRequisiteId, actedDateRequisiteId, sortBy) {
  ClearSearch(searchName);
  setTimeout(() => {
    //Устанавливаем текущего пользователя
    $.when(WA.UserInfoInit).then(() => {
      let jRequisite = $('#' + actedByRequisiteId);
      jRequisite.Clear();
      let newValue = [
        `${Constants.usersReference.REFERENCE_NAME}:${WA.current.user.ID}`,
        WA.current.user.fullName,
        WA.current.user.fullName,
      ];
      jRequisite.SetValue(newValue, false);

      //Устанавливаем период поиска за последние 2 недели
      let lastWeek = (new Date()).getTime() - 2 * 7 * 24 * 60 * 60 * 1000;
      let fromDate = new Date(lastWeek);

      $('#Search')
        .find(`input[id$=${actedDateRequisiteId}]`)
        .val(formatDate(fromDate));

      ExecuteSearch(searchName, sortBy);
    });
  }, 0);
}